
module.exports = [
  'M16 0 L21 11 L32 12 L23 19 L26 31 L16 25 L6 31 L9 19 L0 12 L11 11'
].join(' ')




//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/geomicons-open/src/paths/star.js
// module id = 351
// module chunks = 6